import React from 'react';
import {Show, useRecordContext, useTranslate} from 'react-admin';
import {Box, Typography} from '@mui/material';
import {t} from '../themes/statamicTokens';
import PageHeader from '../components/statamic/PageHeader';
import SectionCard from '../components/statamic/SectionCard';
import DataRow from '../components/statamic/DataRow';
import MonoChip from '../components/statamic/MonoChip';
import {formatDateTime} from '../lib/dates';

const UserActionLogsShowContent = () => {
    const record = useRecordContext();
    const translate = useTranslate();

    if (!record) return null;

    return (
        <Box sx={{backgroundColor: t.color.page, minHeight: '100%'}}>
            <PageHeader
                breadcrumb={{label: translate('User Action Logs'), to: '/userActionLogs'}}
                title={<Box component="span">{record.action || `Action #${record.id}`}</Box>}
                subtitle={formatDateTime(record.date) ?? undefined}
            />

            <Box sx={{p: 3, display: 'flex', flexDirection: 'column', gap: 2}}>
                <SectionCard title={translate('Details')}>
                    <Box sx={{display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', columnGap: 3, rowGap: 0}}>
                        <DataRow label="ID">
                            {record.id != null ? <MonoChip>{record.id}</MonoChip> : null}
                        </DataRow>
                        <DataRow label="User ID">
                            {record.nofam_user_id != null ? <MonoChip>{record.nofam_user_id}</MonoChip> : null}
                        </DataRow>
                        <DataRow label="Platform">
                            {record.platform ? <MonoChip>{record.platform}</MonoChip> : null}
                        </DataRow>
                        <DataRow label="Method">
                            {record.method ? <MonoChip>{record.method}</MonoChip> : null}
                        </DataRow>
                        <DataRow label="Action" value={record.action}/>
                        <DataRow label={translate('Date')} value={formatDateTime(record.date)}/>
                    </Box>
                    <Box sx={{mt: 2}}>
                        <DataRow label="Endpoint">
                            {record.endpoint ? (
                                <Typography sx={{fontSize: `${t.type.body.size}px`, fontFamily: t.font.mono, color: t.color.text.primary, wordBreak: 'break-all'}}>
                                    {record.endpoint}
                                </Typography>
                            ) : null}
                        </DataRow>
                    </Box>
                </SectionCard>
            </Box>
        </Box>
    );
};

const UserActionLogsShowStatamic = (props) => (
    <Show {...props} actions={false} component={Box} sx={{backgroundColor: t.color.page}}>
        <UserActionLogsShowContent/>
    </Show>
);

export default UserActionLogsShowStatamic;
